
import LazyLoad from "react-lazyload";
import { Link } from 'react-router-dom'
const MediumInstruction = () => {
    return (
        <>
            <div className="breadcrumb">
                <h2>Medium of Instruction</h2>
                <ul>
                    <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
                    <li>|</li>
                    <li>Academics</li>
                    <li>|</li>
                    <li>Medium of Instruction</li>
                </ul>
            </div>
            <div className="inner_page">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="instrucion">
                            <LazyLoad> <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/instructions.jpg" alt="st franscis school, Amritsar" className="img-fluid bordered_img" /></LazyLoad>
                            </div>
                            </div>
                        <div className="col-md-8">
                            <p>The medium of instruction is English and the method of study is in accordance with the scheme laid down by the Council for the Primary, Secondary and the Higher Secondary stages approved by the council.</p>
                            <p>Special importance is given to English, including spoken English, for which a high standard is maintained. Hindi as the national language and Punjabi as the regional language are taught form per-primary level with priority.</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MediumInstruction
